import { render, staticRenderFns } from "./fileView.vue?vue&type=template&id=404f2cb5&scoped=true&"
import script from "./fileView.vue?vue&type=script&lang=js&"
export * from "./fileView.vue?vue&type=script&lang=js&"
import style0 from "./fileView.vue?vue&type=style&index=0&id=404f2cb5&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f2cb5",
  null
  
)

component.options.__file = "fileView.vue"
export default component.exports